import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FadeIn from 'react-fade-in';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal'
import './Contact.css';




 const Contact = () => {
  
  
  
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const form = useRef();

  const checkValues = (e) => {
    // the 2 lines below will stop the default form submit action
     e.preventDefault();
     e.stopPropagation();
     let name = document.getElementById("name").value;
     let email = document.getElementById("email").value;
     let number = document.getElementById("number").value;
     let message = document.getElementById("message").value;

     if (!name) {
       alert("Please fill in name field");
     }
     else if (!email) {
      alert("Please fill in email field");
    }else if (!message) {
      alert("Please fill in message field");
    }else if (!number) {
      alert("Please fill in phone number field");
    }else {
      sendEmail(e);
     }
   }
  const sendEmail = (e) => {
    handleShow();
    e.preventDefault();

    emailjs.sendForm('service_a40msgt', 'template_lq65n6o', form.current, 'AVrErWOAqfNNJiC-Y')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
  };

  return (
    
    <FadeIn>
      
      <br></br>
      <center><h1><strong>Contact Us!</strong></h1></center>
      <form ref={form} onSubmit={checkValues}>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Email Sent!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your email was successfully sent! We will respond ASAP!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>

      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label for="from_name">Name</Form.Label>
        <Form.Control type="name" id = "name" name="from_name" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control 
          type="email" 
          id="email" 
          name="from_email" 
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.com$" 
          required
          placeholder="example@domain.com"
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicNumber">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control 
          type="tel" 
          id="number" 
          name="from_number" 
          pattern="^\d{3}-\d{3}-\d{4}$" 
          required
          placeholder="123-456-7890"
        />
      </Form.Group>


      <Form.Group className="mb-3" controlId="formBasicHear">
        <Form.Label for="from_hear">How Did You Hear About Us?</Form.Label>
        <Form.Control type="hear" id = "hear" name="from_hear" />
      </Form.Group>

      <textarea name="message" id = "message" rows={10}/>
      
      <br></br>
      <center><Button type="submit" value="Send">
        Submit
      </Button></center>
      </form>
     
    </FadeIn>
 
  );
}

export default Contact;